/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateKwzDto
 */
export interface CreateUpdateKwzDto {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateKwzDto
     */
    publicationNumber: number;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateKwzDto
     */
    publicationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    decisionSignId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    decisionIndexId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    productionCountry: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    incompatibility: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    danger: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    buyBackOrder: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    destructionOrder: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    other: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateKwzDto
     */
    approved: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    tariffCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    organizationalUnitId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    judgmentId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    productBatchNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    withdrawalInfo: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    removalIncompatibility: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzDto
     */
    stopActivity: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateKwzDto
     */
    request: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateKwzDto
     */
    requestApproved: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateKwzDto
     */
    requestDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateKwzDto
     */
    removePublishDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateKwzDto
     */
    approvedDate?: Date | null;
}

export function CreateUpdateKwzDtoFromJSON(json: any): CreateUpdateKwzDto {
    return CreateUpdateKwzDtoFromJSONTyped(json, false);
}

export function CreateUpdateKwzDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateKwzDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'publicationNumber': json['publicationNumber'],
        'publicationDate': !exists(json, 'publicationDate') ? undefined : (json['publicationDate'] === null ? null : new Date(json['publicationDate'])),
        'decisionSignId': json['decisionSignId'],
        'decisionIndexId': json['decisionIndexId'],
        'productionCountry': json['productionCountry'],
        'incompatibility': json['incompatibility'],
        'danger': json['danger'],
        'buyBackOrder': json['buyBackOrder'],
        'destructionOrder': json['destructionOrder'],
        'other': json['other'],
        'approved': json['approved'],
        'tariffCode': json['tariffCode'],
        'organizationalUnitId': json['organizationalUnitId'],
        'judgmentId': json['judgmentId'],
        'productBatchNumber': json['productBatchNumber'],
        'withdrawalInfo': json['withdrawalInfo'],
        'removalIncompatibility': json['removalIncompatibility'],
        'stopActivity': json['stopActivity'],
        'request': json['request'],
        'requestApproved': json['requestApproved'],
        'requestDate': !exists(json, 'requestDate') ? undefined : (json['requestDate'] === null ? null : new Date(json['requestDate'])),
        'removePublishDate': !exists(json, 'removePublishDate') ? undefined : (json['removePublishDate'] === null ? null : new Date(json['removePublishDate'])),
        'approvedDate': !exists(json, 'approvedDate') ? undefined : (json['approvedDate'] === null ? null : new Date(json['approvedDate'])),
    };
}

export function CreateUpdateKwzDtoToJSON(value?: CreateUpdateKwzDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'publicationNumber': value.publicationNumber,
        'publicationDate': value.publicationDate === undefined ? undefined : (value.publicationDate === null ? null : value.publicationDate.toISOString()),
        'decisionSignId': value.decisionSignId,
        'decisionIndexId': value.decisionIndexId,
        'productionCountry': value.productionCountry,
        'incompatibility': value.incompatibility,
        'danger': value.danger,
        'buyBackOrder': value.buyBackOrder,
        'destructionOrder': value.destructionOrder,
        'other': value.other,
        'approved': value.approved,
        'tariffCode': value.tariffCode,
        'organizationalUnitId': value.organizationalUnitId,
        'judgmentId': value.judgmentId,
        'productBatchNumber': value.productBatchNumber,
        'withdrawalInfo': value.withdrawalInfo,
        'removalIncompatibility': value.removalIncompatibility,
        'stopActivity': value.stopActivity,
        'request': value.request,
        'requestApproved': value.requestApproved,
        'requestDate': value.requestDate === undefined ? undefined : (value.requestDate === null ? null : value.requestDate.toISOString()),
        'removePublishDate': value.removePublishDate === undefined ? undefined : (value.removePublishDate === null ? null : value.removePublishDate.toISOString()),
        'approvedDate': value.approvedDate === undefined ? undefined : (value.approvedDate === null ? null : value.approvedDate.toISOString()),
    };
}


